/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type RouterService from "@ember/routing/router-service";
import type Transition from "@ember/routing/transition";
import { service } from "@ember/service";
import saveSendMessage from "parog-web/components/chat/utils/save-send-message";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import type { Payload } from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import MedicalImagingPrescribedJournalEvent from "parog-web/models/medical-imaging-prescribed-journal-event";
import type AnalyticsService from "parog-web/services/analytics";
import { sortBy } from "parog-web/utils/sort";
interface Model extends Payload {
  willSendMessage: boolean;
  chatMessage: string;
}

export default class MedicalImagingEditionFormComponent extends CrudJournalEventBaseComponent {
  @service declare analytics: AnalyticsService;
  @service declare router: RouterService;

  static fullComponentId = "prescription/medical-imaging-edition-form";
  static forcDisplayName = "Prescription d'imagerie ou d'examen médical";

  static journalEventClass = MedicalImagingPrescribedJournalEvent;
  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  async save(): Promise<void> {
    if (!this.isDirty) {
      return;
    }

    const model = await super.save();

    if (this.patient.authorizesAppUsage) {
      await saveSendMessage(model as Model, {
        store: this.store,
        patient: this.args.patient,
        analytics: this.analytics
      });

      await this.store
        .createRecord("patient-chat-message-sent-journal-event", {
          occurredAt: new Date(),
          triggeringJournalEvent: model,
          patient: model.patient,
          body: "Nouvelle ordonnance reçue"
        })
        .save();
    }

    await this._openPrescriptionInNewTab();
  }

  async _openPrescriptionInNewTab(): Promise<void> {
    // The last JE created of the given type should be the JE saved in the form.
    const journalEvent = this.store
      .peekAll("medical-imaging-prescribed-journal-event")
      // @ts-expect-error the @types/ember-data types are wrong.
      .toSorted(sortBy("occurredAt", "desc"))
      .at(-1);

    // Open the PDF prescription in a new tab
    if (journalEvent) {
      this.router.transitionTo(
        "medics-web.protected.patients.patient.prescriptions.medical-imaging-display",
        journalEvent.patient.id,
        journalEvent.id
      );
    } else {
      throw new Error(
        "Impossible to open the PDF prescription because there is no JournalEvent found corresponding to the type : medical-imaging-prescribed-journal-event"
      );
    }
  }

  afterCompleted = (): Transition =>
    this.router.transitionTo("medics-web.protected.patients.patient.dashboard");
}
